import { render, staticRenderFns } from "./SearchNav.vue?vue&type=template&id=5642191f&scoped=true&"
import script from "./SearchNav.vue?vue&type=script&lang=js&"
export * from "./SearchNav.vue?vue&type=script&lang=js&"
import style0 from "./SearchNav.vue?vue&type=style&index=0&id=5642191f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642191f",
  null
  
)

export default component.exports